import { Directive } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

/**
 * `[tbTooltip]` — the one tooltip. Thin `hostDirectives` wrap of Angular Material's `MatTooltip`
 * (DESIGN.md §3, "Wrap, don't expose": app code imports `@toybank/ui`, never
 * `@angular/material` directly, so a future tooltip-implementation swap is contained here).
 *
 * Usage — identical to `matTooltip`, just renamed:
 *   <button [tbTooltip]="'Toggle dark mode'" [tbTooltipPosition]="'below'">…</button>
 *
 * Owner UX critique (2026-09-14): the top-bar icon-only controls (dark-mode toggle, dense-mode
 * toggle, notification bell, sign-out, and the debug-wrapper's "Toggle Debug Login Wrapper"
 * icon) had an `aria-label` but nothing visible on hover for a sighted mouse user to confirm what
 * an icon-only button does. `[tbTooltip]` is the shared fix — bind it to the SAME string already
 * used for the button's `aria-label` (never a second, drifting copy) so the on-screen tooltip and
 * the accessible name always agree.
 */
@Directive({
  selector: '[tbTooltip]',
  standalone: true,
  hostDirectives: [{
    directive: MatTooltip,
    inputs: ['matTooltip: tbTooltip', 'matTooltipPosition: tbTooltipPosition'],
  }],
})
export class TbTooltipDirective {}
